// extracted by mini-css-extract-plugin
module.exports = {"mostDiscussedItem":"style_mostDiscussedItem__FUQzi","timeSpan":"style_timeSpan__t2lUD","desc":"style_desc__IeG0T","timestamp":"style_timestamp__8nh1k"};